export class Roles {
  public static agent = "agent"
  public static broker = "broker"
}
